import { useState, useRef, useEffect } from "react";
import { useDispatch } from "react-redux";
import { toggleShowPickupDropdown } from "../Store/modalStatusSlice";

const useMainSearch = () => {
  const [showModal, setShowModal] = useState({
    pickup: false,
    drop: false,
    calendarAndTime: false,
  });

  const containerRef = useRef(null);
  const dispatch = useDispatch()

  const handleToggle = (modal) => {
    setShowModal((currentModal) => ({
      ...{
        pickup: false,
        drop: false,
        calendarAndTime: false,
      },
      [modal]: !currentModal[modal],
    }));
  };

  const handlePickupSelect = () => {
    // handleToggle("drop");
    handleToggle("calendarAndTime");//it will directly open the calendarAndTime when u click pickup option value
  };

  const handleDropSelect = () => {
    handleToggle("calendarAndTime");
  };

  const handleSiteMapSelect = () => {
    handleToggle("pickup")
  }

  const handleClickOutside = (event) => {
    dispatch(toggleShowPickupDropdown(false));//this send false to showModalPickupDropDown in store
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      setShowModal({
        pickup: false,
        drop: false,
        calendarAndTime: false,
      });
    }
  };

  useEffect(() => {
    window.addEventListener("mousedown", handleClickOutside);
    return () => window.removeEventListener("mousedown", handleClickOutside);
  }, 
  // eslint-disable-next-line
  []);

  return {
    containerRef,
    showModal,
    handleToggle,
    handlePickupSelect,
    handleDropSelect,
    handleSiteMapSelect
  };
};

export default useMainSearch;
